import getConfig from 'next/config'
import { Integrations } from 'types/integration'
import { postApiRequest } from 'utils/fetch-helper'

export function connectStripe({
    stripe_code: code,
    tenant_id: tenantId,
    integration_id: integrationId,
    normalized_id: normalizedId,
    location_id: locationId
} : {
    stripe_code: string,
    tenant_id: string,
    integration_id: string,
    normalized_id?: string,
    location_id?: string
}) {
    let url = `/v1/stripe/connect?code=${code}&tenantId=${tenantId}&integrationId=${integrationId}`
    if (locationId) {
        url += `&locationId=${locationId}`
    }
    return postApiRequest(url, {
        code,
        integrationId: normalizedId || integrationId,
        tenantId,
        locationId
    })
}

export function createExpressAccount({
    tenant_id: tenantId,
    integration_id: integrationId,
    normalized_id: normalizedId,
    location_id: locationId
} : {
    tenant_id: string,
    integration_id: string,
    normalized_id?: string,
    location_id?: string
}) {
    let url = `/v1/stripe/express-account?tenantId=${tenantId}&integrationId=${integrationId}`
    if (locationId) {
        url += `&locationId=${locationId}`
    }
    return postApiRequest(url, {
        integrationId: normalizedId || integrationId,
        tenantId,
        locationId
    })
}

export function disconnectStripe(stripe_id: string) {
    return postApiRequest(`/v1/stripe/disconnect?stripeUserId=${stripe_id}`)
}

export function getIntegrationConnectUrl(
    name: string,
    params: string[] = []
) {
    const { STRIPE_CLIENT_ID, DASHBOARD_HOST } = getConfig().publicRuntimeConfig

    switch (name) {
        case Integrations.STRIPE:
            const query = new URLSearchParams(location.search)
            const integrations_url = [
                DASHBOARD_HOST,
                location.pathname,
            ].join('')
            return `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${encodeURIComponent(
                integrations_url
            )}&state=${encodeURIComponent(query.toString())}${
                params.length > 0
                    ? encodeURIComponent([''].concat(params).join('&'))
                    : ''
            }`
        default:
            return ''
    }
}

export function getIntegrationDisconnectUrl(
    name: string,
    connection_id: string
) {
    switch (name) {
        case Integrations.STRIPE:
            return `/v1/stripe/disconnect?stripeUserId=${connection_id}`
        default:
            return ''
    }
}